<template>
  <Tabs v-model="sortingOutTab" :animated="false" class="tabs_styles">
    <TabPane :label="$t('key1003987')" name="onventionalSorting">
      <onventionalSorting v-if="sortingOutTab === 'onventionalSorting'"></onventionalSorting>
    </TabPane>
    <TabPane :label="$t('key1003988')" name="choiceSorting">
      <choiceSorting v-if="sortingOutTab === 'choiceSorting'"></choiceSorting>
    </TabPane>
  </Tabs>
</template>

<script>
import onventionalSorting from "@/views/yms/components/collectionManage/onventionalSorting";
import choiceSorting from "@/views/yms/components/collectionManage/choiceSorting";

export default {
  name: 'sortingOut',
  data() {
    return {
      sortingOutTab: 'onventionalSorting'
    };
  },
  components: {
    onventionalSorting,
    choiceSorting
  }
};
</script>

<style lang="less" scoped>
.tabs_styles {
  /deep/ .ivu-tabs-bar {
    border-bottom: none;
    background-color: #fff;
    padding: 8px 0 3px 10px;
    margin: 0;
  }
}
</style>


